import { startCase } from 'lodash';

/**
 * Converts a string to start case if it is all uppercase.
 * @param value
 * @returns
 */
export function convertUpperCasetoStartCase(value: string | undefined): string | undefined {
    if (!value || value !== value.toUpperCase()) {
        return value;
    }

    return value
        .toLowerCase()
        .split(/([^a-zA-Z0-9]+)/) // Split by non-alphanumeric characters but keep them in the result
        .map((part) => (/[^a-zA-Z0-9]/.test(part) ? part : startCase(part))) // Apply startCase only to alphanumeric parts
        .join('');
}
